import { CostDealType, B2CDealType, B2BDealType } from "@/app/constants";
import { Pricing } from "../../entities/pricing";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { Space } from "../../entities/space";
import { ReactiveComponent } from "../../entities/base-component";

export class SummaryTotalCalculationStrategy extends CalculationStrategy {
    calculate = (
        component: ReactiveComponent,
        [spaces, totalInstallationSum, totalDeliveryPrice],
    ): PriceResult => {
        return {
            price: this.calculatePriceForType(
                spaces,
                totalInstallationSum,
                totalDeliveryPrice,
                CostDealType,
            ),
            priceB2C: this.calculatePriceForType(
                spaces,
                totalInstallationSum,
                totalDeliveryPrice,
                B2CDealType,
            ),
            priceB2B: this.calculatePriceForType(
                spaces,
                totalInstallationSum,
                totalDeliveryPrice,
                B2BDealType,
            ),
        };
    };

    private calculatePriceForType(
        spaces: Space[],
        totalInstallationSum: Pricing,
        totalDeliveryPrice: Pricing,
        dealType: string,
    ): number {
        const totalSum = spaces.reduce((total, space) => {
            // partition sum = door sum + overdoor sum + mounts sum + discounted extra sum
            const partitionsSum = space.getAllPartitions()?.reduce((partitionsTotalSum, partition) => {
                return partitionsTotalSum + partition?.sum.getSystemPrice(dealType).getValue() || 0;
            }, 0);

            const overheadSum = space.getOverheads()?.sum.getSystemPrice(dealType).getValue() || 0;

            return total + partitionsSum + overheadSum;
        }, 0);

        const totalInstallationSumValue = totalInstallationSum?.getSystemPrice(dealType).getValue() || 0;
        const totalDeliveryPriceValue = totalDeliveryPrice?.getSystemPrice(dealType).getValue() || 0;

        return totalSum + totalInstallationSumValue + totalDeliveryPriceValue;
    }
}
